import { render, staticRenderFns } from "./MakeTab2.vue?vue&type=template&id=4f265afd&scoped=true&lang=pug&"
import script from "./MakeTab2.vue?vue&type=script&lang=js&"
export * from "./MakeTab2.vue?vue&type=script&lang=js&"
import style0 from "./MakeTab2.vue?vue&type=style&index=0&id=4f265afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f265afd",
  null
  
)

export default component.exports